import React from 'react';
import PropTypes from 'prop-types';

const SuggestionsItem = ({
    name = "",
    image = "",
    imageFallback = "",
    teamAbbreviation = null,
    tagUrl,
    active = false,
    onClickHandler,
}) => {

    const clickHandler = (event) => {

        event.preventDefault();
        onClickHandler(tagUrl);

    };

    return (
        <li className={`suggestions-item ${active ? 'suggestions-item--active': ''}`}>
            <a onClick={e => clickHandler(e)} className="suggestions-item__link">
                <img
                    src={image}
                    alt={name}
                    className="suggestions-item__image"
                    onError={(e) => e.target.src = imageFallback}
                />
                <span className="suggestions-item__name">{name}</span>
                {teamAbbreviation && <span className="suggestions-item__team-abbreviation">{teamAbbreviation}</span>}
            </a>
        </li>
    );

};

SuggestionsItem.propTypes = {
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    imageFallback: PropTypes.string,
    teamAbbreviation: PropTypes.string,
    tagUrl: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
};

export default SuggestionsItem;
